import { ComplaintStatus } from "@/components/shared/StatusBadge";

/** Mirrors server/src/services/complaint.service.ts — see shared/constants/complaintStatus.ts for the reference copy. */
export const STATUS_TRANSITIONS: Record<ComplaintStatus, ComplaintStatus[]> = {
  PENDING: ["ASSIGNED", "CANCELLED"],
  ASSIGNED: ["INSPECTION", "CANCELLED"],
  INSPECTION: ["WAITING_PARTS", "REPAIRING", "CANCELLED"],
  WAITING_PARTS: ["REPAIRING", "CANCELLED"],
  REPAIRING: ["TESTING", "CANCELLED"],
  TESTING: ["REPAIRING", "COMPLETED", "CANCELLED"],
  COMPLETED: ["DELIVERED"],
  DELIVERED: [],
  CANCELLED: [],
};

export function nextStatusOptions(current: ComplaintStatus): ComplaintStatus[] {
  return STATUS_TRANSITIONS[current];
}
